module.exports = "/_next/static/images/d6a8c755fe48d58d330de30b8adf5452-limit-lg.png.webp";